import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN, FETCH_PROFILE } from "./actionTypes"
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  fetchProfile,
  fetchProfileSuccess,
  fetchProfileFailure,
} from "./actions"
import { login, getAuthProfile, postLogout } from "../../../helpers/backend-helper"
import { setThemeColor } from "store/actions"

function* loginUser({ payload: { user, history } }) {
  try {
    const { data } = yield call(login, user);

    yield put(loginSuccess(data?.user));
    yield put(setThemeColor(data?.user?.company?.primaryColor || "#06427a"));
    yield put(fetchProfile());

    localStorage.setItem("themeColor", data?.user?.company?.primaryColor || "#06427a");

    const loggedUser = data?.user;
    if (loggedUser?.mustChangePassword) {
      history("/change-password");
    } else if ([3, 4].includes(Number(loggedUser?.role))) {
      history("/home");
    } else {
      history("/dashboard");
    }
  } catch (err) {
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong";
    yield put(apiError(msg));
  }
}

function* fetchProfileSaga() {
  try {
    const response = yield call(getAuthProfile);
    const user = response?.data?.user || response?.user || response?.data || response;
    yield put(fetchProfileSuccess(user));
    yield put(setThemeColor(user?.company?.primaryColor || "#06427a"));
  } catch {
    yield put(fetchProfileFailure());
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    yield call(postLogout);
  } catch {
    // proceed with local cleanup even if server logout fails
  }
  yield put(logoutUserSuccess());
  history("/signin");
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeLatest(FETCH_PROFILE, fetchProfileSaga)
}

export default authSaga
